import http from 'http'
import server from 'src/utils/server'

export const getTaxes = (params) => {
  return http.get(server.url_to('taxes/?' + params))
  .then((response) => {
    return response
  })
  .catch(function (error) {
    return error.response
  })
}

export const getTax = (id) => {
  return http.get(server.url_to('taxes/' + id))
  .then((response) => {
    return response
  })
  .catch(function (error) {
    return error.response
  })
}

export const newTax = (params) => {
  return http.post(server.url_to('taxes/'), params)
  .then((response) => {
    return response
  })
  .catch(function (error) {
    return error.response
  })
}

export const updateTax = (params) => {
  return http.put(server.url_to('taxes/' + params.id), params)
  .then((response) => {
    return response
  })
  .catch(function (error) {
    return error.response
  })
}



// WEBPACK FOOTER //
// ./src/app/pages/taxes/services.js